/**
 * A constants file that will map each keyboard keyCode to a sensible value
 */
define([], () => ({
    Enter: 13
}));
